import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import Link from 'next/link';
import styles from 'sections/Resources/FreightTemplates/CommercialInvoice/components/SectionAbout/SectionAbout.module.scss';

const cn = classNames.bind(styles);

const SectionAbout = (): ReactElement => {
  return (
    <section className={cn('about')}>
      <div className={cn('container')}>

        <div className={cn('about__description')}>
          <h2 className={cn('about__heading')}>
            What is Commercial Invoice?
          </h2>
          <p className={cn('about__paragraph')}>
            At its core, the Commercial Invoice is the bill of sale between the seller and the buyer. 
            But in international logistics, it does a lot of heavy lifting. 
            It tells the story of the transaction: who sold what, for how much, and under what 
            rules (<Link href='/blog/incoterms-cif-cost-insurance-and-freight'>Incoterms</Link>). 
            It’s the primary data source for import declarations. If the value here is wrong, the duties are wrong, and that triggers audits.
          </p>
          <div className={cn('about__buttons')}>
            <a
              className={cn('about__button-download-word')}
              href='/download/Resources/FreightTemplates/commercial_invoice.docx'
              target='_blank'
            >
              Download (Word)
            </a>
            <a
              className={cn('about__button-download-pdf')}
              href='/download/Resources/FreightTemplates/commercial_invoice.pdf'
              target='_blank'
            >
              Download (pdf)
            </a>
          </div>
        </div>

        {/* TODO: uncomment when picture is provided */}
        {/* <div className={cn('about__image-container')}>
          <picture>
            <source
              srcSet="/images/pages/Resources/FreightTemplates/BillOfLading/template@2x.webp 2x, 
                      /images/pages/Resources/FreightTemplates/BillOfLading/template.webp 1x"
              sizes="100vw"
            />
            <img
              className={cn('about__image')}
              src="/images/pages/Resources/FreightTemplates/BillOfLading/template.webp"
              alt="template"
            />
          </picture>
        </div> */}

      </div>
    </section>
  );
};

export default SectionAbout;